import _ from 'lodash'
export default {
    dataInnerContent(data_comments, name_parameter, number_parameter){
        let content_comment = _.find(data_comments, (comment) => {return comment.parameter_name === name_parameter})
        let result_content_comments = []

        content_comment.content.forEach((comm, index) => {
            if (comm.name !== 'Консультации'){
                result_content_comments.push({text: `${number_parameter}.${index + 1} ${comm.name} – ${comm.comments ? comm.comments : 'да'}\n`})
            }
        })

        return result_content_comments
    },
    commentAdditionally(data_comments, name_parameter){
        return _.find(data_comments, (comment) => {return comment.parameter_name === name_parameter}).comments
    },
    createPDF(data_tm, name_discipline, data_comments, addit_message) {
        pdfMake.fonts = {
            Times: {
                normal: 'TimesNewRomanCyrRegular.TTF',
                bold: 'TimesNewRomanCyrBold.TTF',
                italics: 'TimesNewRomanCyrItalic.TTF',
                bolditalics: 'TimesNewRomanCyrBoldItalic.TTF'
            }
        };
        const docInfo = {
            info: {
                title: `Оценочный лист соответствия ЭУК`,
                author: 'АмГУ',
                subject: '',
                keywords: ''
            },

            pageSize: 'A4',
            pageOrientation: 'portrait',

            content: [
                {
                    text: 'Оценочный лист соответствия ЭУК\n',
                    style: 'title'
                },
                {
                    text: `\nДисциплина: ${name_discipline}`,
                    style: 'subtitle'
                },
                {
                    text: `Автор: ${data_tm.full_name}`,
                    style: 'subtitle'
                },
                {
                    text: '\n\n',
                    style: 'base_text'
                },

                {
                    text: '1. Содержательное наполнение модуля «Аннотация ЭУК»',
                    style: 'base_text_list'
                },
                {
                    text: this.dataInnerContent(data_comments, 'Аннотация ЭУК', 1),
                    style: 'inner_base_text_list'
                },
                {
                    text:[
                        {text: '\nДополнительно: ', style: 'bold_additionally'},
                        {text: `${ this.commentAdditionally(data_comments, 'Аннотация ЭУК') ? this.commentAdditionally(data_comments, 'Аннотация ЭУК') : 'замечания отсутствуют'}`}
                    ],
                    style: 'base_text'
                },

                {
                    text: '\n2. Содержательное наполнение модуля «Вводный модуль»',
                    style: 'base_text_list'
                },
                {
                    text: this.dataInnerContent(data_comments, 'Вводный модуль', 2),
                    style: 'inner_base_text_list'
                },
                {
                    text:[
                        {text: '\nДополнительно: ', style: 'bold_additionally'},
                        {text: `${this.commentAdditionally(data_comments, 'Вводный модуль') ? this.commentAdditionally(data_comments, 'Вводный модуль') : 'замечания отсутствуют'}`}
                    ],
                    style: 'base_text'
                },

                {
                    text: '\n3. Содержательное наполнение модуля «Тематический модуль»',
                    style: 'base_text_list'
                },
                {
                    text: this.dataInnerContent(data_comments, 'Тематический модуль', 3),
                    style: 'inner_base_text_list'
                },
                {
                    text:[
                        {text: '\nДополнительно: ', style: 'bold_additionally'},
                        {text: `${this.commentAdditionally(data_comments, 'Тематический модуль')? this.commentAdditionally(data_comments, 'Тематический модуль'): 'замечания отсутствуют'}`}
                    ],
                    style: 'base_text'
                },

                {
                    text: `\n4. Содержательное наполнение модуля «Модуль промежуточной аттестации» – ${this.commentAdditionally(data_comments, 'Содержательное наполнение модуля «Модуль промежуточной аттестации»') ? this.commentAdditionally(data_comments, 'Тематический модуль') : 'замечания отсутствуют'}`,
                    style: 'base_text_list'
                },

                {
                    text: `\n5. Содержательное наполнение модуля «Модуль оценки качества» – ${this.commentAdditionally(data_comments, 'Содержательное наполнение модуля «Модуль оценки качества»') ? this.commentAdditionally(data_comments, 'Тематический модуль') : 'замечания отсутствуют'}`,
                    style: 'base_text_list'
                },

                {
                    text:[
                        {text: '\nОбщее дополнение: ', style: 'bold_additionally'},
                        {text: `${addit_message.length === 0 ? 'Общий комментарий отсутствует' : addit_message}`}
                    ],
                    style: 'base_text'
                },

                {
                    text: '\n\n\nЦЭОиДПО',
                    alignment: 'right',
                    style: 'base_text'
                }

            ],

            styles: {
                base_text: {
                    fontSize: 12,
                    margin: [20, 0, 0, 0],
                    alignment: 'justify',
                    font: 'Times'
                },
                base_text_list: {
                    fontSize: 12,
                    margin: [40, 0, 0, 0],
                    alignment: 'justify',
                    font: 'Times'
                },
                inner_base_text_list: {
                    fontSize: 12,
                    margin: [50, 0, 0, 0],
                    alignment: 'justify',
                    font: 'Times'
                },
                title: {
                    fontSize: 16,
                    alignment: 'center',
                    bold: true,
                    font: 'Times'
                },
                subtitle:{
                    fontSize: 12,
                    margin: [20, 0, 0, 0],
                    alignment: 'center',
                    bold: true,
                    font: 'Times'
                },
                header: {
                    fontSize: 9,
                    alignment: 'center',
                    font: 'Times'
                },
                normal: {
                    fontSize: 9,
                    alignment: 'justify',
                    font: 'Times',
                    leadingIndent: 18
                },
                column: {
                    fontSize: 9,
                    alignment: 'left',
                    font: 'Times'
                },
                tableBase: {
                    fontSize: 12,
                    font: 'Times'
                },
                tableSupport: {
                    fontSize: 14,
                    font: 'Times'
                },
                bold_additionally: {
                    fontSize: 12,
                    bold: true,
                    font: 'Times'
                }
            }
        }
        pdfMake.createPdf(docInfo).download(`Оценочный лист ЭУК - ${data_tm.course_full_name}.pdf`);
    }
}